import { createContext } from 'react';

const sistemaContext = createContext();

export default sistemaContext;